import Cookies from 'js-cookie'

const COOKIE_NAME = 'allow_cookies'
const COOKIE_EXPIRY_DAYS = 365

export function initCookiesBar(): void {
  const cookiesBar = document.getElementById('cookies-bar')
  if (!cookiesBar) return

  let cookiesAllowed = Cookies.get(COOKIE_NAME)

  const allowCookies = (): void => {
    Cookies.set(COOKIE_NAME, 'yes', { expires: COOKIE_EXPIRY_DAYS })
    cookiesAllowed = 'yes'
    cookiesBar.style.display = 'none'
  }

  const closeBarLink = cookiesBar.querySelector('.close-bar')
  closeBarLink?.addEventListener('click', () => {
    if (cookiesAllowed !== 'yes') {
      allowCookies()
    }
  })

  if (cookiesAllowed === 'yes') {
    allowCookies()
  }
}
